module.exports = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array);
  }
};

// https://gist.github.com/Atinux/fd2bcce63e44a7d3addddc166ce93fb2
